import { GOHIGHLEVEL_CONFIG } from '../../../config/gohighlevel.config';

/**
 * Realiza una petición a la API de GoHighLevel
 * @param {string} endpoint - Endpoint de la API
 * @param {string} method - Método HTTP
 * @param {object} data - Datos a enviar
 * @returns {Promise<object>} Respuesta de la API
 * @throws {Error} Si la petición falla
 */
export const makeApiRequest = async (endpoint, method, data) => {
  try {
    const response = await fetch(`${GOHIGHLEVEL_CONFIG.API_URL}${endpoint}`, {
      method,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${GOHIGHLEVEL_CONFIG.API_KEY}`,
        'Version': '2021-07-28'
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(`API request failed: ${response.statusText} - ${JSON.stringify(errorData)}`);
    }

    return await response.json();
  } catch (error) {
    console.error('GoHighLevel API Error:', error);
    throw error;
  }
}; 